<template>
  <div>
    <v-tooltip location="top" v-if="disabled">
      <template v-slot:activator="{ props }">
        <div v-bind="props" class="fit">
          <outline-button disabled>
            {{ t('warehouse.pages.settings.buttons.previewSchedulingPortal') }}
          </outline-button>
        </div>
      </template>
      <span>{{ t('warehouse.pages.settings.tooltips.saveSettingsToEnablePreviewMode') }}</span>
    </v-tooltip>
    <outline-button small v-else @click="jumpToLunaPreview()" :loading="loading">
      {{ t('warehouse.pages.settings.buttons.previewSchedulingPortal') }}
    </outline-button>
  </div>
</template>

<script>
import { t } from '@nova/core';
import config from '@/config/config';
import { isEnabled } from '@/utils';
import {
  OPENER_HANDOFF_QUERY_VALUE,
  openWindowWithHandoff
} from '@satellite/helpers/opener-handoff';

export default {
  name: 'PreviewAsCarrierButton',
  props: {
    /**
     * Warehouse Object
     */
    warehouse: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    t,
    async jumpToLunaPreview() {
      this.loading = true;
      try {
        const routeJSON = JSON.stringify({
          name: 'warehouse.details',
          params: { warehouseId: this.warehouse.id }
        });
        if (isEnabled('enable-handoff-preview-as-carrier')) {
          const opened = await openWindowWithHandoff({
            url: `${config.luna_url}?handoff=${OPENER_HANDOFF_QUERY_VALUE}&nextRoute=${routeJSON}`,
            getAccessToken: async () => {
              const res = await axios.post('/carrier/preview', {});
              return res.data?.access_token;
            }
          });
          if (!opened) {
            this.notify(
              t('warehouse.pages.settings.messages.couldNotOpenTheCarrierPortal'),
              'error'
            );
          }
          return;
        }
        const res = await axios.post('/carrier/preview', {});
        window.open(
          `${config.luna_url}?token=${res.data.access_token}&nextRoute=${routeJSON}`,
          '_blank'
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.fit {
  width: fit-content;
}
</style>
